'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactRouter = require('react-router');
var _groupBy = require('lodash/groupBy');var _groupBy2 = _interopRequireDefault(_groupBy);
var _values = require('lodash/values');var _values2 = _interopRequireDefault(_values);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _isEqual = require('lodash/isEqual');var _isEqual2 = _interopRequireDefault(_isEqual);
var _invariant = require('@turf/invariant');
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _MapContainer = require('./MapContainer.scss');var styles = _interopRequireWildcard(_MapContainer);
var _MapboxService = require('../../services/MapboxService/MapboxService');var _MapboxService2 = _interopRequireDefault(_MapboxService);
var _constants = require('../../services/MapboxService/constants');










var _constants2 = require('../../constants');






var _components = require('../../components');






var _getLocalizedData = require('../../utils/getLocalizedData');var _getLocalizedData2 = _interopRequireDefault(_getLocalizedData);
var _images_placeholder = require('../../../static/images/images_placeholder.svg');var _images_placeholder2 = _interopRequireDefault(_images_placeholder);
var _modifyImageLink = require('../../utils/modifyImageLink');var _modifyImageLink2 = _interopRequireDefault(_modifyImageLink);
var _formatAddress = require('../../utils/formatAddress');var _formatAddress2 = _interopRequireDefault(_formatAddress);
var _google = require('../../utils/analytics/google');
var _routerAdapter = require('../../helpers/routerAdapter');
var _MapContainerLocationInput = require('../../components/LocationInput/MapContainerLocationInput/MapContainerLocationInput');var _MapContainerLocationInput2 = _interopRequireDefault(_MapContainerLocationInput);

var _googleService = require('../../helpers/googleService');var _googleService2 = _interopRequireDefault(_googleService);
var _helpers = require('../../services/MapboxService/helpers');
var _helpers2 = require('./helpers');





var _analyticsManager = require('../../utils/analytics/analyticsManager');
var _analyticsConstants = require('../../utils/analytics/analyticsConstants');



var _slugify = require('../../helpers/slugify');var _slugify2 = _interopRequireDefault(_slugify);
var _drawnPolygonQuery = require('./drawn-polygon-query');var _drawnPolygonQuery2 = _interopRequireDefault(_drawnPolygonQuery);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}var

MapContainer = function (_Component) {_inherits(MapContainer, _Component);function MapContainer() {var _temp, _this, _ret;_classCallCheck(this, MapContainer);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    state = {
      mapIsReady: false,
      updateLocation: false,
      isZoomToFavorites: false,
      polygonName: '' }, _this.




















































































































































    getMapRef = function (mapContainer) {_this.mapContainer = mapContainer;}, _this.

    handleLocaleChange = function () {
      _MapboxService2.default.addStaticCitiesLayer(_this.map, _this.map.getZoom(), _this.props.isMobile);
      _MapboxService2.default.addStreetsLayer(_this.map);
      _this.reInitMapIcons();
      _this.renderMapPins();var _this$props =

      _this.props,cityOrNeighborhoodPolygon = _this$props.cityOrNeighborhoodPolygon,cityOrNeighborhoodPolygonName = _this$props.cityOrNeighborhoodPolygonName,routeData = _this$props.routeData;

      if (cityOrNeighborhoodPolygon) {
        _this.showPolygon(cityOrNeighborhoodPolygon, cityOrNeighborhoodPolygonName, _this.props, true);
      } else {
        _this.initSavedDrawnPolygon();var

        locationSearch = routeData.locationSearch;
        var streetName = (0, _get2.default)(locationSearch, 'en.street_name');
        var isStreet = !locationSearch.isCity && !locationSearch.isFull && !locationSearch.isNeighborhood;

        if (isStreet && streetName) {
          _this.showStreet(locationSearch, true);
        }
      }
    }, _this.

    handleMapLoad = function () {
      _MapboxService2.default.addStaticCitiesLayer(_this.map, _this.map.getZoom(), _this.props.isMobile);
      _MapboxService2.default.addStreetsLayer(_this.map);
      _this.renderMapPins();
      var updateLocation = !!(0, _get2.default)(_this.props, 'routeData.locationSearch.location');

      _this.map.on('click', _this.handleMapClick);
      _this.map.on('mousemove', _this.handleMapMouseMove);
      _this.map.on('moveend', _this.handleMapIdle);
      _this.map.on('contextmenu', _this.handleContextMenu);
      _this.map.on('zoomend', _this.handleZoom);
      _this.map.on('click', _constants.STATIC_CITIES_LAYOUT_ID, _this.handlePolygonClick);
      _this.map.on('mousemove', _constants.STATIC_CITIES_LAYOUT_ID, _this.handlePolygonHover);
      _this.map.on('mouseleave', _constants.STATIC_CITIES_LAYOUT_ID, _this.handlePolygonLeave);

      _this.setState(
      { mapIsReady: true, updateLocation: updateLocation },
      function () {
        _this.initSavedDrawnPolygon();var _this$props2 =

        _this.props,isMobile = _this$props2.isMobile,cityOrNeighborhoodPolygon = _this$props2.cityOrNeighborhoodPolygon,cityOrNeighborhoodPolygonName = _this$props2.cityOrNeighborhoodPolygonName,routeData = _this$props2.routeData;

        if (!(0, _get2.default)(_this.props, 'routeData.mapLoaded') || !(0, _get2.default)(_this.props, 'routeData.locationSearch.location')) {
          _this.map.resize(); // TODO It's fasfix (trigger idle to load pins). Figure out how to solve it.
        }

        if (cityOrNeighborhoodPolygon && !_this._drawnCityPolygon) {
          _this.showPolygon(cityOrNeighborhoodPolygon, cityOrNeighborhoodPolygonName);
        }var _routeData$locationSe =

        routeData.locationSearch,locationSearch = _routeData$locationSe === undefined ? {} : _routeData$locationSe;
        var streetName = (0, _get2.default)(locationSearch, 'en.street_name');
        var isStreet = !locationSearch.isCity && !locationSearch.isFull && !locationSearch.isNeighborhood;

        if (isStreet && streetName) {
          _this.showStreet(locationSearch, true);
          _this.map.resize(); // TODO It's fasfix (trigger idle to load pins). Figure out how to solve it.
        }
        _this.props.routeData.mapLoaded = true;
      });

    }, _this.

    handleZoom = function () {
      var zoom = _this.map.getZoom();

      var newZoomIsCity = zoom < _constants.MAX_CITY_ZOOM;
      var oldZoomIsCity = _this._currentZoom < _constants.MAX_CITY_ZOOM;
      var newZoomIsNeighborhood = zoom > _constants.MAX_CITY_ZOOM;
      var oldZoomIsNeighborhood = _this._currentZoom > _constants.MAX_CITY_ZOOM;

      var zoomLevelIsChanged = newZoomIsNeighborhood && oldZoomIsCity || newZoomIsCity && oldZoomIsNeighborhood;
      var zoomLevelIsWrong = !_this._currentViewLevel ||
      newZoomIsCity && _this._currentViewLevel === 'neighborhood' ||
      newZoomIsNeighborhood && _this._currentViewLevel === 'city';

      if (zoomLevelIsChanged || zoomLevelIsWrong) {
        _this._currentZoom = zoom;
        _this._currentViewLevel = (0, _helpers2.getViewLevelByZoom)(zoom);
        _MapboxService2.default.changeStaticCitiesData(_this.map, _this._currentZoom);
      }
    }, _this.

    handleMapClick = function (evt) {
      if (!_this.map) {return;}

      if (_this.props.cityOrNeighborhoodPolygon) {
        var lat = evt.lngLat.lat;
        var lng = evt.lngLat.lng;
        var pointInside =
        _MapboxService2.default.polygonContainsLocation([lng, lat], _this.props.cityOrNeighborhoodPolygon);


        if (!pointInside) {
          var _features = _this.map.queryRenderedFeatures(evt.point, {
            layers: [_constants.STATIC_CITIES_LAYOUT_ID] });


          if (!_features.length) {var _this$props$routeData =
            _this.props.routeData.locationSearch,location = _this$props$routeData.location,map = _this$props$routeData.map,zoom = _this$props$routeData.zoom;
            _this.updateRoute({ locationSearch: { location: location, map: map, zoom: zoom } });
          }
        }
      }

      if (!_this.map.getLayer(_constants.PINS_LAYOUT_ID)) {return;}

      var features = _this.map.queryRenderedFeatures(evt.point, {
        layers: [_constants.PINS_LAYOUT_ID] });


      if (!features.length) {return;}

      var feature = features[0];

      var ids = JSON.parse((0, _get2.default)(feature, 'properties.ids', '[]'));
      var coordinates = (0, _get2.default)(feature, 'geometry.coordinates', []);
      var zIndex = (0, _get2.default)(feature, 'properties.zIndex');
      var type = (0, _get2.default)(feature, 'properties.type');

      _this.openInfoWindow(ids, coordinates, zIndex, type);
    }, _this.

    handleMapMouseMove = function (evt) {
      if (!_this.map || !_this.map.getLayer(_constants.PINS_LAYOUT_ID)) {return;}

      var features = _this.map.queryRenderedFeatures(evt.point, {
        layers: [_constants.PINS_LAYOUT_ID] });


      _this.map.getCanvas().style.cursor = features.length ? 'pointer' : '';
    }, _this.

    handlePolygonClick = function (evt) {
      var pins = _this.map.queryRenderedFeatures(evt.point, {
        layers: [_constants.PINS_LAYOUT_ID] });


      var popupIsOpen = _this.popup && _this.popup.isOpen();

      if (pins.length || _this.state.drawOnMapIsActive || _this.state.drawnCoordinates || popupIsOpen) {return;}

      var tags = JSON.parse((0, _get2.default)(evt, 'features[0].properties.tags', '[]'));
      var type = (0, _get2.default)(evt, 'features[0].properties.address_type', 'city');
      var searchedTags = (0, _get2.default)(_this.props, 'routeData.locationSearch.tags', []);

      if (tags.length && searchedTags.length && (0, _isEqual2.default)(tags, searchedTags)) {return;}

      tags.length && _this.geocodeByTags(tags, type);
    }, _this.

    handlePolygonHover = function (evt) {
      if (_this.props.isMobile || _this.state.drawOnMapIsActive || _this.state.drawnCoordinates) {return;}
      var stateModifier = {};
      if (_this._hoveredFeatureId || _this._hoveredFeatureId === 0) {
        _this.map.setFeatureState(
        { source: _constants.STATIC_CITIES_SOURCE_ID, id: _this._hoveredFeatureId },
        { hover: false });

        stateModifier.polygonName = null;
      }

      if (evt.features.length > 0) {
        var feature = (0, _get2.default)(evt, 'features[0]');
        var polygonName = (0, _get2.default)(feature, 'properties.name_' + _this.props.locale) || (0, _get2.default)(feature, 'properties.name_en');

        stateModifier.polygonName = polygonName;

        _this.tooltipCoords = evt.point;
        _this._hoveredFeatureId = (0, _get2.default)(feature, 'id');
        _this.map.setFeatureState(
        { source: _constants.STATIC_CITIES_SOURCE_ID, id: _this._hoveredFeatureId },
        { hover: true });

      }

      _this.setState(stateModifier);
    }, _this.

    handlePolygonLeave = function () {
      if (_this._hoveredFeatureId) {
        _this.map.setFeatureState(
        { source: _constants.STATIC_CITIES_SOURCE_ID, id: _this._hoveredFeatureId },
        { hover: false });

      }
      !!_this.state.polygonName && _this.setState({ polygonName: null });
      _this._hoveredFeatureId = null;
    }, _this.

    handleContextMenu = function (evt) {evt.preventDefault();}, _this.

    convertCoords = function (_ref) {var lat = _ref.lat,lng = _ref.lng;return { lat: lat, lon: lng };}, _this.

    handleMapIdle = function () {
      if (!_this.state.mapIsReady || _this.props.isMobile && _this.props.mobileMapIsHidden) {return;}

      if (_this._noSearch) {
        _this._noSearch = false;
        return;
      }

      var bounds = _this.map.getBounds();

      if (!bounds || _this.props.isMobileFiltersOpen) {return;}

      var center = _this.convertCoords(_this.map.getCenter());
      var topright = _this.convertCoords(bounds.getNorthEast());
      var bottomleft = _this.convertCoords(bounds.getSouthWest());
      var zoom = Math.round(_this.map.getZoom());var _ref2 =

      _this.props.routeData || {},oldSearch = _ref2.locationSearch;

      var locationSearch = Object.assign({},
      oldSearch, {
        zoom: zoom,
        location: (0, _helpers2.formatLocationPoint)(center),
        map: (0, _helpers2.formatLocationMap)({ map: { topright: topright, bottomleft: bottomleft } }) });


      var isDetailsOpen = !!(0, _get2.default)(_this.props, 'routeData.searchResultParams.propertyId');
      if (!(0, _isEqual2.default)((0, _get2.default)(locationSearch, 'map'), (0, _get2.default)(oldSearch, 'map')) && !isDetailsOpen) {
        _this.updateRoute({ locationSearch: locationSearch });
        if (!_this.state.updateLocation) {
          _this.setState({ updateLocation: true });
        }
      }

      // if (this.props.isFavoritesPins) {
      //   this.filterFavoritesByViewport(bounds);
      // }
    }, _this.

    handleAutocompleteData = function (locationSearch) {
      _this.deactivateDrawOnMap();
      _this.updateRoute({ locationSearch: locationSearch });
    }, _this.

    highlightPin = function () {var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},pinId = _ref3.id;
      _this._animatedPin && _this._animatedPin.remove();
      _this.togglePinVisibility(_this._hiddenPinId, true);

      if (!pinId || !_this.state.mapIsReady) {return;}

      var highlightedProperty = _this.props.propertyPins.find(function (item) {return item.id === pinId && !item.banners;});

      if (!highlightedProperty) {return;}var

      location = highlightedProperty.address.location;
      var key = location.lat + '|' + location.lon;
      var properties = (0, _get2.default)(_this._groupedPins, key, []);var _this$formatPropertyP =
      _this.formatPropertyPins(properties),lat = _this$formatPropertyP[0],lon = _this$formatPropertyP[1],data = _this$formatPropertyP[2];
      _this._animatedPin = _MapboxService2.default.createPin(lat, lon, Object.assign({}, data, { animated: true }));

      _this.togglePinVisibility(pinId, false);

      _this._animatedPin.addTo(_this.map);
    }, _this.

    togglePinVisibility = function (id, isVisible) {
      if (!id || !_this.map.getLayer(_constants.PINS_LAYOUT_ID)) {return;}
      var features = _this.map.queryRenderedFeatures({ layers: [_constants.PINS_LAYOUT_ID] });
      var feature = features.find(function (item) {
        var ids = (0, _get2.default)(item, 'properties.ids', '[]');
        return JSON.parse(ids).includes(id);
      });

      if (!feature) {return;}
      if (!isVisible) {_this._hiddenPinId = id;}

      _this.map.setFeatureState(feature, { opacity: isVisible ? 1 : 0 });
    }, _this.

    reInitMapIcons = function () {
      var icons = _constants.requiredMapIcons[_constants.MAP_TYPES.SEARCH];
      icons.forEach(function (icon) {return _MapboxService2.default.initIconToMap(_this.map, icon);});
    }, _this.

    clearMap = function () {
      if (!_this.map) {return;}
      _this.map.off('click', _this.handleMapClick);
      _this.map.off('mousemove', _this.handleMapMouseMove);
      _this.map.off('moveend', _this.handleMapIdle);
      _this.map.off('contextmenu', _this.handleContextMenu);
      _this.map.off('zoomend', _this.handleZoom);
      _this.map.off('click', _constants.STATIC_CITIES_LAYOUT_ID, _this.handlePolygonClick);
      _this.map.off('mousemove', _constants.STATIC_CITIES_LAYOUT_ID, _this.handlePolygonHover);
      _this.map.off('mouseleave', _constants.STATIC_CITIES_LAYOUT_ID, _this.handlePolygonLeave);

      _this.map.remove();
    }, _this.

    toggleFavorite = function (id) {
      _this.props.toggleFavorite(id);
    }, _this.

    updateInfoWindowFavoriteContent = function (id) {
      if (_this.popup) {
        var properties = [(0, _get2.default)(_this.props, ['propertiesIdsMap', id], {})];
        var content = _this.createPinContent(properties);

        _MapboxService2.default.setContentToInfoWindow(content, _this.popup);
      }
    }, _this.

    openInfoWindow = function (ids, coordinates, zIndex, type) {
      if (!ids || !ids.length) {return;}
      var content = '';

      if (type === _constants.PIN_TYPES.AGENCY) {
        var agencyData = _this.props.agencies.find(function (agency) {return agency.id === ids[0];}) || {};
        content = _this.createAgencyPinContent(agencyData);
      } else {
        var properties = ids.map(function (id) {return (0, _get2.default)(_this.props, ['propertiesIdsMap', id], {});});
        content = _this.createPinContent(properties);

        _this.props.setPinAsReviewed(ids[0]);
      }

      _this.currentPinData = {
        id: ids[0],
        zIndex: zIndex };


      _this.renderMapPins();

      _this.popup = _MapboxService2.default.createInfoWindow(content).
      setLngLat(coordinates).
      addTo(_this.map);

      _MapboxService2.default.locateInfoWindow(_this.map, coordinates, _this.popup);
    }, _this.

    isFavorite = function (id) {return _this.props.favoriteProperties.includes(id);}, _this.

    fitMapBoundsByFavorites = function () {var favoritesPins = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      if (favoritesPins.length) {
        var bounds = _MapboxService2.default.createBounds();

        var points = favoritesPins.map(function (pin) {return pin.address.location;});
        points.forEach(function (item) {return bounds.extend([item.lon, item.lat]);});
        _this.map.fitBounds(bounds, { padding: 70 });
        _this.setState({ isZoomToFavorites: true });
      }
    }, _this.

    saveMapPosition = function () {
      if (!_this.map) {return;}
      var bounds = _this.map.getBounds();
      var northEast = bounds.getNorthEast();
      var southWest = bounds.getSouthWest();

      _this.setState({ savedMapPosition: { northEast: northEast, southWest: southWest } });
    }, _this.

    applySavedMapPosition = function () {
      if (!_this.state.savedMapPosition) {return;}var _this$state$savedMapP =
      _this.state.savedMapPosition,northEast = _this$state$savedMapP.northEast,southWest = _this$state$savedMapP.southWest;
      var bounds = _MapboxService2.default.createBounds(southWest, northEast);
      _MapboxService2.default.changeMapBounds(_this.map, bounds);
    }, _this.

    initialiseMap = function (locationSearch) {
      var hasAddress = (0, _get2.default)(locationSearch, 'en.formatted');
      var neighborhood = (0, _get2.default)(locationSearch, 'en.neighborhood');
      var cityName = (0, _get2.default)(locationSearch, 'en.city_name');

      var search = locationSearch || _this.props.routeData.locationSearch || {};var
      location = search.location,viewport = search.map,zoom = search.zoom;

      var defaultOptions = Object.assign({}, _MapboxService2.default.getMapOptions('search', _this.props.isRtl));
      var center = Object.assign({}, defaultOptions.center);
      var defaultZoom = zoom || defaultOptions.zoom;

      if (location) {
        center.lat = location.lat || center.lat;
        center.lng = location.lon || center.lng;
      }

      var options = Object.assign({},
      defaultOptions, {
        center: center,
        zoom: defaultZoom,
        bounds: hasAddress && viewport.bottomleft && viewport.topright ?
        [viewport.bottomleft, viewport.topright] :
        undefined });


      _this.map = _MapboxService2.default.createMapInstance(
      _this.mapContainer,
      options,
      _this.props.locale,
      _constants.requiredMapIcons[_constants.MAP_TYPES.SEARCH]);


      _this.map.once('load', _this.handleMapLoad);
      _this.map.dragRotate.disable();
      _this.map.touchZoomRotate.disableRotation();
    }, _this.

    geocodeFromRoute = function () {return new Promise(function (resolve) {
        var location = _this.props.routeData.locationSearch;

        // TODO: Remove optimisation and always geocode?
        var hasZoom = location && location.location && location.zoom;
        if (hasZoom) {resolve(location);return;}

        var hasViewport = location && location.map && Object.keys(location.map).length !== 0;
        if (hasViewport) {resolve(location);return;}

        var hasEnglish = location && location.en && Object.keys(location.en).length !== 0;
        if (!hasEnglish) {resolve();return;}

        // Default to geocoding from scratch
        var address = '';
        var streetName = location.en.street_name ? location.en.street_name + '. ' : '';
        var houseNumber = location.en.house_number ? location.en.house_number + ', ' : '';
        var cityName = location.en.city_name ? location.en.city_name : '';
        var neighborhoodName = location.en.neighborhood && location.en.neighborhood !== location.en.city_name ? location.en.neighborhood : '';
        address = '' + streetName + houseNumber + cityName + neighborhoodName;
        if (!address) {resolve();return;}

        var tags = [];
        if (cityName) {
          tags.push(cityName);
          if (houseNumber) {
            tags.push(streetName);
            tags.push(houseNumber);
          } else if (streetName) {
            tags.push(streetName);
          } else if (neighborhoodName) {
            tags.push(neighborhoodName);
          }
        }
        var cleanedTags = tags.
        filter(function (part) {return !!part;}).
        map(function (keyPart) {return (0, _slugify2.default)(keyPart);});
        resolve(_this.googleService.geocodeLocusViaInternalBase(address, cleanedTags, _this.map));
      });}, _this.

    geocodeByTags = function (tags, type) {
      _this.googleService.searchLocusByTags(tags, type).
      then(function (resp) {return resp.data && _googleService2.default.formatLegacyGoogleResponse(resp.data);}).
      then(function (locationSearch) {
        if (locationSearch.polygon && !Object.keys(locationSearch.map).length) {
          locationSearch.map = _MapboxService2.default.calcViewportByPolygon(_this.map, locationSearch.polygon.geometry);
        }

        _this.updateRoute({ locationSearch: locationSearch });
      });
    }, _this.

    formatPropertyPins = function (propertiesArray) {
      var isFavorite = false;
      var isReviewed = false;
      var type = _constants.PIN_TYPES.PROPERTY;
      var isSinglePropertyPin = propertiesArray.length === 1;

      var location = (0, _get2.default)(propertiesArray, '[0].address.location');
      if (location) {
        var ids = propertiesArray.map(function (item) {return item.id;});var
        lat = location.lat,lon = location.lon;
        var firstProperty = propertiesArray[0];

        isReviewed = ids.some(function (id) {return _this.props.reviewedPins.includes(id);});
        type = firstProperty.entityType === _constants2.ENTITY_TYPES.PROJECT || _this.props.isProjects ?
        _constants.PIN_TYPES.PROJECT : _constants.PIN_TYPES.PROPERTY;

        var shouldMoveOnTop = _this.currentPinData && ids.includes(_this.currentPinData.id);
        var zIndex = _this.currentPinData && (shouldMoveOnTop ?
        _this.currentPinData.zIndex + 1 :
        _this.currentPinData.zIndex);

        if (isSinglePropertyPin) {var
          id = firstProperty.id;
          isFavorite = _this.isFavorite(id);
          type = isFavorite ? _constants.PIN_TYPES.FAVORITE : type;
        }

        return [lat, lon, {
          ids: ids,
          type: type,
          reviewed: isReviewed,
          number: ids.length,
          propertiesArray: propertiesArray,
          isProject: _this.props.isProjects,
          zIndex: zIndex || 1 }];

      }

      return [];
    }, _this.

    formatAgencyPin = function (agencyData) {
      if (agencyData.address.location && agencyData.search.enabled) {var _agencyData$address$l = Object.assign({},
        agencyData.address.location),lat = _agencyData$address$l.lat,lon = _agencyData$address$l.lon;
        var type = _constants.PIN_TYPES.AGENCY;

        return [lat, lon, {
          type: type,
          ids: [agencyData.id]
          // zIndex: zIndex || 1
        }];
      }

      return [];
    }, _this.

    createProjectPinContent = function (project) {var _this$props3 =
      _this.props,locale = _this$props3.locale,isMobile = _this$props3.isMobile,openDetailsPopup = _this$props3.openDetailsPopup,translate = _this$props3.translate;
      var name = (0, _getLocalizedData2.default)(project.name, locale);
      var address = (0, _getLocalizedData2.default)(project.address, locale, true);
      var image = (0, _get2.default)(project, 'images[0]') || _images_placeholder2.default;
      var modifiedPhoto = (0, _modifyImageLink2.default)(image, _constants2.imageModifierTypes.PROJECT_THUMBNAIL);
      var statusLocaliseData = _constants2.projectStatuses.find(function (item) {return item.name === project.status;}) || {};
      var status = (0, _getLocalizedData2.default)(statusLocaliseData.localisation, locale);

      return (
        _react2.default.createElement(_components.ProjectCellWrapper, {
          isPinInfoWindow: true,
          isMobile: isMobile,
          openDetailsPopup: openDetailsPopup,
          id: project.id,
          childProps: {
            image: modifiedPhoto,
            price: project.min_property_price,
            exactPrice: project.exact_property_price,
            isMobile: isMobile,
            locale: locale,
            name: name.result,
            address: address.result || {},
            status: status.result,
            translate: translate } }));



    }, _this.

    createPinContent = function (properties) {var _this$props4 =
      _this.props,isProjects = _this$props4.isProjects,locale = _this$props4.locale;
      var multiple = properties.length > 1 && !isProjects;
      var firstProperty = properties[0] || {};
      var lang = firstProperty.address[locale] ? locale : _constants2.language.fallback;
      var address = firstProperty.address[lang];
      var shouldHideHouseNumber = properties.some(function (item) {return !(0, _get2.default)(item, 'address[' + lang + '].house_number');});
      var houseNumber = shouldHideHouseNumber ? ', ' : ' ' + address.house_number + ', ';

      var addressString = multiple ?
      _react2.default.createElement('div', { className: styles.addressMultiPin }, '' +
        address.street_name + houseNumber + address.city_name) :

      null;

      return (
        _react2.default.createElement('div', {
            className: multiple ? styles.multipleCellWrap : '' },

          addressString,

          isProjects || firstProperty.entityType === _constants2.ENTITY_TYPES.PROJECT ?
          _this.createProjectPinContent(properties[0]) :

          _react2.default.createElement(_components.OMPropertiesList, {
            properties: properties,
            isMobile: _this.props.isMobile,
            locale: locale,
            translate: _this.props.translate,
            className: multiple ? 'multiPinList' : '',
            openDetailsPopup: _this.props.openDetailsPopup,
            needScroll: multiple,
            favoriteProperties: _this.props.favoriteProperties,
            toggleFavorite: _this.toggleFavorite,
            mapPropertyCell: true,
            isRtl: _this.props.isRtl,
            suppressLoading: _this.props.suppressLoading,
            todayDate: _this.todayDate })));





    }, _this.

    createAgencyPinContent = function (agencyData) {var _this$props5 =
      _this.props,locale = _this$props5.locale,translate = _this$props5.translate;
      var nameAtCurrentLang = (0, _get2.default)(agencyData, 'name[' + locale + ']');
      var nameAtDefaultLang = (0, _get2.default)(agencyData, 'name[' + _constants2.language.default + ']');

      var titleAtCurrentLang = (0, _get2.default)(agencyData, 'title[' + locale + ']');
      var titleAtDefaultLang = (0, _get2.default)(agencyData, 'title[' + _constants2.language.default + ']');

      var address = (0, _formatAddress2.default)(agencyData.address[locale] || agencyData.address.en);

      return (
        _react2.default.createElement(_components.AgencyInfoWindow, {
          locale: locale,
          name: nameAtCurrentLang || nameAtDefaultLang,
          nameAtDefaultLang: !nameAtCurrentLang,
          title: titleAtCurrentLang || titleAtDefaultLang,
          titleAtDefaultLang: !titleAtCurrentLang,
          address: address,
          image: agencyData.image,
          pageLinkTitle: translate('companyPage', 'agencyPageLink').toString(),
          doesAgencyPageExist: agencyData.page,
          agencyId: agencyData.id }));


    }, _this.

    updateRoute = function (data, force) {
      var routeData = _this.props.routeData;
      var canGenerate = routeData.location || force;

      if (!canGenerate) {return;}

      var routeParams = Object.assign({},
      routeData,
      data, {
        drawnPoly: _this.state.drawnCoordinates,
        mapLoaded: _this.state.mapIsReady });


      if (
      !force && ((0, _isEqual2.default)(routeData, routeParams) ||
      !routeParams.locationSearch ||
      !routeParams.locationSearch.map))
      {return;}

      // Pre-filter incorrect rectangles
      var _routeParams$location = routeParams.locationSearch,location = _routeParams$location.location,topright = _routeParams$location.map.topright;
      if (
      !_this.state.mapIsReady ||
      location && topright && (location.lat === topright.lat || location.lon === topright.lon))
      {return;}

      // Check whether to add the location params
      var noLocationBefore = !(routeData.locationSearch && routeData.locationSearch.location);
      var firstLoad = noLocationBefore && !routeData.firstLoad;var _ref4 =

      routeParams.locationSearch || {},isCity = _ref4.isCity,isFull = _ref4.isFull,isNeighborhood = _ref4.isNeighborhood;
      var isStreet = routeParams.locationSearch && !isCity && !isFull && !isNeighborhood;
      var route = (0, _routerAdapter.createUrl)(routeParams);

      // Add params
      routeParams.cancelDraw = force;
      routeParams.firstLoad = firstLoad;
      var replace = _this.state.updateLocation === false;
      var method = replace ? 'replace' : 'push';
      var pathname = replace && !isStreet ? (0, _routerAdapter.deleteLocation)(route) : route;

      _reactRouter.browserHistory[method]({ pathname: pathname, state: routeParams });
    }, _this.

    showStreet = function (locationSearch, immediately) {
      var highlightStreet = function highlightStreet() {
        var features = _this.map.queryRenderedFeatures();
        var filtered = (0, _helpers2.filterStreetFeatures)(features, locationSearch);

        var streetSource = _this.map.getSource(_constants.STREET_SOURCE_ID);
        streetSource && streetSource.setData({ type: 'FeatureCollection', features: filtered });
      };

      if (immediately) {
        highlightStreet();
      } else {
        _this.map.once('idle', highlightStreet);
      }
    }, _this.

    clearStreet = function () {
      if (!_this.map) {return;}
      var streetSource = _this.map.getSource(_constants.STREET_SOURCE_ID);
      if (!streetSource) {return;}
      streetSource.setData({ type: 'FeatureCollection', features: [] });
    }, _this.

    showPolygon = function (poly, name) {var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _this.props;var noFit = arguments[3];
      if (!_this.state.mapIsReady) {
        return;
      }

      var isGeoJson = !!(0, _get2.default)(poly, 'type');
      var currentSource = _this.map.getSource(_constants.CITY_POLYGON_SOURCE_ID);

      _this.clearStreet();

      if (currentSource) {
        var data = isGeoJson ? poly : (0, _helpers.makeGeoJsonPolygon)(poly);
        currentSource.setData(data);
      } else {
        _MapboxService2.default.addPolygon(_this.map, poly);
      }

      var route = (0, _get2.default)(props, 'routeData.route', '');
      var isFirstLoad = ['c_', 't_'].every(function (it) {return !route.includes(it);});

      if (!noFit && (!_this._drawnCityPolygon && isFirstLoad || name !== props.cityOrNeighborhoodPolygonName)) {
        var polyCoords = isGeoJson ? poly.features.map(function (it) {return (0, _invariant.getCoords)(it);}) : poly;
        var isNeighborhood = (0, _get2.default)(props, 'routeData.locationSearch.isNeighborhood');
        _this._noSearch = !isNeighborhood && name !== 'drawn';
        _MapboxService2.default.fitBoundsToPolygon(_this.map, polyCoords);
      }
      _this._drawnCityPolygon = name;
    }, _this.

    clearCityOrNeighborhoodPolygon = function () {
      _this._drawnCityPolygon = null;
      _MapboxService2.default.removePolygon(_this.map);
    }, _this.

    activateDrawOnMap = function () {
      _this.clearStreet();var
      locationSearch = _this.props.routeData.locationSearch;
      var isStreet = !locationSearch.isCity && !locationSearch.isFull && !locationSearch.isNeighborhood;

      if (_this.props.cityOrNeighborhoodPolygon || isStreet) {var _this$props$routeData2 =
        _this.props.routeData.locationSearch,location = _this$props$routeData2.location,map = _this$props$routeData2.map,zoom = _this$props$routeData2.zoom;
        _this.updateRoute({ locationSearch: { location: location, map: map, zoom: zoom } });
      }

      (0, _analyticsManager.trackEvent)(_analyticsConstants.eventCategory.searchResults, _analyticsConstants.eventAction.click, _analyticsConstants.eventLabel.drawOnMap);

      _this.setState({ drawOnMapIsActive: true });
    }, _this.

    deactivateDrawOnMap = function () {
      if (!_this.state.drawnCoordinates) {
        _this.setState({ drawOnMapIsActive: false });
        return;
      }

      _this.clearCityOrNeighborhoodPolygon();
      _constants2.storage.value.removeItem('polygonCoordinates');

      _this.setState(
      { drawOnMapIsActive: false, drawnCoordinates: null },
      function () {return _this.updateRoute({}, true);});

    }, _this.

    removePolygon = function () {
      _this.clearCityOrNeighborhoodPolygon();
      _this.props.resetNeighborhoodCompany();var _this$props$routeData3 =
      _this.props.routeData.locationSearch,location = _this$props$routeData3.location,map = _this$props$routeData3.map,zoom = _this$props$routeData3.zoom;

      if (!map || Object.keys(map).length === 0) {
        _MapboxService2.default.changeMapZoom(_this.map, location, zoom);
      }

      _this.updateRoute({ locationSearch: { location: location, map: map, zoom: zoom } });
    }, _this.

    applyDrawnPolygon = function (pointCoordinates, location) {
      if (pointCoordinates.length > 1) {
        pointCoordinates.push(pointCoordinates[0]);
        var drawnCoordinates = _MapboxService2.default.convertPointsToCoordinates(pointCoordinates, _this.map);
        var simplifiedPoly = _MapboxService2.default.simplifyPolygon(drawnCoordinates);
        var formattedPoly = (0, _drawnPolygonQuery2.default)(simplifiedPoly);

        var serverData = _this.formatDrawnPolygonDataForServer(formattedPoly);

        _this.showPolygon(formattedPoly, 'drawn');

        _this.setState({
          drawOnMapIsActive: false,
          drawnCoordinates: serverData });


        // if (this.props.isMobile) {
        (0, _helpers2.savePolygonToStorage)(formattedPoly, {});
        // }
      }
    }, _this.

    formatDrawnPolygonDataForServer = function (geojson) {
      var polyCoords = geojson.features.map(function (it) {return (0, _invariant.getCoords)(it);});
      return _MapboxService2.default.convertMultiPolygonToArray(polyCoords);
    }, _this.

    initSavedDrawnPolygon = function () {
      var polygonData = _constants2.storage.value.getItem('polygonCoordinates');

      if (polygonData) {
        var data = {};
        try {
          data = JSON.parse(polygonData);
        } catch (err) {
          console.error(err);
        }var _data =

        data,coords = _data.coords;
        _this.showPolygon(coords, 'drawn', _this.props, true);

        var serverData = _this.formatDrawnPolygonDataForServer(coords);

        _this.setState({
          drawnCoordinates: serverData });

      }
    }, _this.

    renderMapPins = function () {var propertyPins = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props.propertyPins;var agencies = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.props.agencies;
      if (!_this.map) return null;

      _this._groupedPins = (0, _groupBy2.default)(propertyPins, function (_ref5) {var _ref5$address$locatio = _ref5.address.location,lat = _ref5$address$locatio.lat,lon = _ref5$address$locatio.lon;return lat + '|' + lon;});

      var propertiesPinsData = (0, _values2.default)(_this._groupedPins).map(_this.formatPropertyPins);
      var agenciesPinsData = agencies.map(_this.formatAgencyPin);
      var pinsData = [].concat(propertiesPinsData, agenciesPinsData);

      var currentSource = _this.map.getSource(_constants.PINS_SOURCE_ID);

      if (currentSource) {
        var geoJsonPinsData = _MapboxService2.default.createGeoJsonPinsData(pinsData);
        currentSource.setData(geoJsonPinsData);
      } else {
        var geoJsonPins = _MapboxService2.default.createGeoJsonPins(pinsData);
        _MapboxService2.default.applyPinsGeoJson(_this.map, geoJsonPins);
      }

      return _this.map;
    }, _this.

    renderCancelDrawButton = function () {return (
        _react2.default.createElement('div', {
            className: (0, _classnames2.default)(styles.drawButton, styles.cancelDrawButton),
            onClick: _this.deactivateDrawOnMap },

          _react2.default.createElement('span', null, _this.props.translate('mapContainer', 'cancel'))));}, _this.



    renderStartDrawButton = function () {return (
        _react2.default.createElement('div', {
            title: _this.props.translate('mapContainer', 'drawCustomArea'),
            className: (0, _classnames2.default)(styles.drawButton, styles.startDrawButton),
            onClick: _this.activateDrawOnMap },

          _react2.default.createElement('span', null, _this.props.translate('mapContainer', 'drawOnMap')),
          _react2.default.createElement('i', { className: 'icon icon-draw-onmap' })));}, _temp), _possibleConstructorReturn(_this, _ret);}MapContainer.prototype.componentDidMount = function componentDidMount() {var _this2 = this; // this.initialiseMap();
    this.props.resetNeighborhoodCompany();new _googleService2.default(this.props.locale, function (gs) {// eslint-disable-line no-new
      _this2.googleService = gs;_this2.geocodeFromRoute().then(_this2.initialiseMap);});this.todayDate = new Date();if (this.props.isMobile) {this.sessionStart = Date.now();}};MapContainer.prototype.componentWillReceiveProps = function componentWillReceiveProps(newProps) {var localeIsChanged = newProps.locale && newProps.locale !== this.props.locale;var favoritesChanged = newProps.isFavoritesPins !== this.props.isFavoritesPins;var _newProps$routeData = newProps.routeData,_newProps$routeData$l = _newProps$routeData.locationSearch,locationSearch = _newProps$routeData$l === undefined ? {} : _newProps$routeData$l,pointCoordinates = _newProps$routeData.pointCoordinates,firstLoad = _newProps$routeData.firstLoad;var location = locationSearch.location,map = locationSearch.map,zoom = locationSearch.zoom;if (localeIsChanged && this.state.drawnCoordinates) {this.updateRoute({ locationSearch: { location: location, map: map, zoom: zoom } });}if (localeIsChanged) {_MapboxService2.default.changeMapLocale(this.map, newProps.locale, this.handleLocaleChange);}if (newProps.fitMapToFavorites && newProps.fitMapToFavorites !== this.props.fitMapToFavorites) {this.fitMapBoundsByFavorites(newProps.propertyPins);} else if (newProps.isFavoritesPins) {if (favoritesChanged) {this.saveMapPosition();this.fitMapBoundsByFavorites(newProps.propertyPins);}if (newProps.isMobile && newProps.isMobile !== this.props.isMobile) {this.fitMapBoundsByFavorites(newProps.propertyPins);}} else if (!newProps.isFavoritesPins && favoritesChanged) {this.applySavedMapPosition();}var polyName = newProps.cityOrNeighborhoodPolygonName,polyPoints = newProps.cityOrNeighborhoodPolygon;var _props = this.props,oldPolyName = _props.cityOrNeighborhoodPolygonName,oldPolyPoints = _props.cityOrNeighborhoodPolygon;var polygonChanged = polyName && polyName !== oldPolyName;var shouldRenderPolygon = polyPoints && (!oldPolyPoints || polygonChanged || !this._drawnCityPolygon);if (!newProps.cityOrNeighborhoodPolygon && this.props.cityOrNeighborhoodPolygon) {this.clearCityOrNeighborhoodPolygon();}if (!polyName && polyName !== oldPolyName) {this.props.resetNeighborhoodCompany();}if (shouldRenderPolygon) {this.deactivateDrawOnMap();this.showPolygon(polyPoints, oldPolyName, newProps);}if (locationSearch.location) {var _props$routeData$loca = this.props.routeData.locationSearch,oldLocationSearch = _props$routeData$loca === undefined ? {} : _props$routeData$loca;var zoomChanged = locationSearch.zoom && locationSearch.zoom !== oldLocationSearch.zoom;var viewportChanged = !!(!oldLocationSearch.location && locationSearch.location || (0, _helpers2.isLocationChanged)(locationSearch, oldLocationSearch));var newCityName = (0, _get2.default)(locationSearch, 'en.city_name');var isCityChanged = locationSearch.isCity && newCityName !== (0, _get2.default)(oldLocationSearch, 'en.city_name');var streetName = (0, _get2.default)(locationSearch, 'en.street_name');var addressIsChanged = (0, _get2.default)(locationSearch, 'en.formatted') !== (0, _get2.default)(oldLocationSearch, 'en.formatted');var isStreet = !locationSearch.isCity && !locationSearch.isFull && !locationSearch.isNeighborhood;if (isStreet && streetName && addressIsChanged) {this.showStreet(locationSearch);} else if (!isStreet) {this.clearStreet();}if ((!firstLoad || firstLoad && (newProps.isMobile || addressIsChanged)) && (zoomChanged || viewportChanged)) {if (!shouldRenderPolygon && isCityChanged || !locationSearch.isCity && !locationSearch.isNeighborhood) {if ((0, _get2.default)(locationSearch, 'map.topright', null)) {var _formatLocationMap = (0, _helpers2.formatLocationMap)(locationSearch),bottomleft = _formatLocationMap.bottomleft,topright = _formatLocationMap.topright;if (!!bottomleft.lat && !!topright.lat && !!bottomleft.lon && !!topright.lon) {var options = isStreet && addressIsChanged ? { padding: 50 } : {};_MapboxService2.default.changeMapBoundsByViewport(this.map, { topright: topright, bottomleft: bottomleft }, options);}} else {_MapboxService2.default.changeMapZoom(this.map, locationSearch.location, locationSearch.zoom);}}}}this.highlightPin(newProps.highlightedProperty || undefined);};MapContainer.prototype.componentDidUpdate = function componentDidUpdate(oldProps, oldState) {if (!this.state.mapIsReady) {return;}var reviewedPropertiesIsChanged = !(0, _isEqual2.default)(oldProps.reviewedPins, this.props.reviewedPins);var favoritePropertiesIsChanged = !(0, _isEqual2.default)(oldProps.favoriteProperties, this.props.favoriteProperties);var pinsIsChanged = !(0, _isEqual2.default)(oldProps.propertyPins, this.props.propertyPins);var agenciesIsChanged = !(0, _isEqual2.default)(oldProps.agencies, this.props.agencies);var backFromList = oldProps.mobileMapIsHidden && !this.props.mobileMapIsHidden;var backFromFilters = oldProps.isMobileFiltersOpen && !this.props.isMobileFiltersOpen;if (this.props.isMobile && (backFromList || backFromFilters)) {this.map.resize();}if (pinsIsChanged || agenciesIsChanged || reviewedPropertiesIsChanged || favoritePropertiesIsChanged) {this.renderMapPins();}if (!this.state.isZoomToFavorites && this.props.isFavoritesPins) {this.fitMapBoundsByFavorites(this.props.propertyPins);}if (favoritePropertiesIsChanged && this.popup && this.popup.isOpen()) {var popupId = this.currentPinData && this.currentPinData.id;this.updateInfoWindowFavoriteContent(popupId);}if (!this.props.routeData.mapLoaded) {this.props.routeData.mapLoaded = true;}};MapContainer.prototype.componentWillUnmount = function componentWillUnmount() {if (this.props.isMobile) {this.sessionEnd = Date.now();var time = this.sessionEnd - this.sessionStart;(0, _google.gaSetTimedEvent)({ page: 'Properties Search', time: time, label: 'Map - Mobile' });}this.clearMap();_MapboxService2.default.cleanup();if (!this.props.isMobile) {this.updateRoute({ drawnPoly: null });}};MapContainer.prototype.

  render = function render() {var _cx;
    var showCancelButton = this.state.mapIsReady && (this.state.drawOnMapIsActive || this.state.drawnCoordinates);
    var drawButton = showCancelButton ? this.renderCancelDrawButton() : this.renderStartDrawButton();

    if (typeof document !== 'undefined' && showCancelButton) {
      document.body.style.overflow = 'hidden';
    } else if (typeof document !== 'undefined' && !showCancelButton) {
      document.body.style.overflow = '';
    }

    var totalPropertiesCount = this.props.isFavoritesPins ?
    this.props.favoriteProperties && this.props.favoriteProperties.length :
    (this.props.propertiesQuantity || 0) + (this.props.projectsQuantity || 0);var

    locationSearch = this.props.routeData.locationSearch;var
    locale = this.props.locale;
    var localisedData = locationSearch && locationSearch[locale] && locationSearch[locale].formatted;
    var defaultData = locationSearch && locationSearch.en && locationSearch.en.formatted;

    var locationInputValue = localisedData || defaultData || '';

    var shouldRenderLocationInput = !this.props.isMobile && this.state.mapIsReady && !this.props.isFavoritesPins;
    var locationInput = !!shouldRenderLocationInput &&
    _react2.default.createElement(_MapContainerLocationInput2.default, {
      locale: this.props.locale,
      placeholder: '' + this.props.translate('mapContainer', 'locationInputPlaceholder'),
      buttonTitle: '' + this.props.translate('mapContainer', 'searchButtonTitle'),
      getInputData: this.handleAutocompleteData,
      mapIsReady: this.state.mapIsReady,
      locationValue: locationInputValue,
      googleService: this.googleService,
      isLargeSideBar: this.props.isLargeSideBar });



    var drawOverlay = this.state.drawOnMapIsActive ?
    _react2.default.createElement('div', { className: styles.drawOverlay },
      _react2.default.createElement(_components.DrawingOverlay, {
        isMobile: this.props.isMobile,
        width: '' + (this.mapContainer && this.mapContainer.clientWidth),
        height: '' + (this.mapContainer && this.mapContainer.clientHeight),
        lineWidth: _constants2.drawOnMapOptions.strokeWeight,
        lineColor: _constants2.drawOnMapOptions.strokeColor,
        applyDrawnPolygon: this.applyDrawnPolygon })) :


    null;

    return (
      _react2.default.createElement('div', {
          className: (0, _classnames2.default)(styles.mapContainer, (_cx = {}, _cx[styles.favoritesMap] = this.props.isFavoritesPins, _cx)) },


        _react2.default.createElement('div', { ref: this.getMapRef, className: styles.map },
          _react2.default.createElement('div', {
              className: styles.polyTooltip,
              style: {
                visibility: !!this.state.polygonName ? 'visible' : 'hidden',
                opacity: !!this.state.polygonName ? 1 : 0,
                top: (0, _get2.default)(this, 'tooltipCoords.y', 0) + 25,
                left: (0, _get2.default)(this, 'tooltipCoords.x', 0) } },


            this.state.polygonName)),



        locationInput,

        _react2.default.createElement('div', { className: styles.propertiesCounterWrapper },
          _react2.default.createElement(_components.PropertiesCounter, {
            isMobile: this.props.isMobile,
            totalProperties: totalPropertiesCount,
            visibleProperties: this.props.propertyPins.length,
            loading: this.props.pinsLoading,
            translate: this.props.translate('mapPropertiesCount'),
            shouldRenderActionText: !!this.props.cityOrNeighborhoodPolygonName,
            actionText: this.props.translate('mapContainer', 'removeBoundary'),
            actionHandler: this.removePolygon })),



        drawOverlay,

        !this.props.isFavoritesPins && drawButton,

        _react2.default.createElement('div', { className: styles.locationWrapper },
          _react2.default.createElement(_components.CurrentLocation, { map: this.map, isMobile: this.props.isMobile }))));



  };return MapContainer;}(_react.Component);exports.default = MapContainer;


MapContainer.propTypes = {
  locale: _propTypes2.default.string,
  propertyPins: _propTypes2.default.array,
  propertiesIdsMap: _propTypes2.default.object,
  agencies: _propTypes2.default.array,
  isProjects: _propTypes2.default.bool,
  reviewedPins: _propTypes2.default.array,
  favoriteProperties: _propTypes2.default.array,
  isFavoritesPins: _propTypes2.default.bool,
  setPinAsReviewed: _propTypes2.default.func,
  isMobile: _propTypes2.default.bool,
  translate: _propTypes2.default.func,
  openDetailsPopup: _propTypes2.default.func,
  toggleFavorite: _propTypes2.default.func,
  isRtl: _propTypes2.default.bool,
  projectsQuantity: _propTypes2.default.number,
  propertiesQuantity: _propTypes2.default.number,
  pinsLoading: _propTypes2.default.bool,
  routeData: _propTypes2.default.object,
  isLargeSideBar: _propTypes2.default.bool,
  highlightedProperty: _propTypes2.default.object,
  fitMapToFavorites: _propTypes2.default.bool,
  mobileMapIsHidden: _propTypes2.default.bool,
  suppressLoading: _propTypes2.default.func,
  cityOrNeighborhoodPolygon: _propTypes2.default.array,
  cityOrNeighborhoodPolygonName: _propTypes2.default.string,
  isMobileFiltersOpen: _propTypes2.default.bool,
  resetNeighborhoodCompany: _propTypes2.default.func,
  userToken: _propTypes2.default.string };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/MapContainer/MapContainer.js
// module id = 2982
// module chunks = 0